<template>
  <i style="display: none !important;"/>
</template>

<script>
import esriComponent from '../../mixins/esri-component';
import esriVisible from '../../mixins/visible';

import {loadModules} from 'esri-loader';

export default {
  inject: ['getGraphics'],
  mixins: [esriComponent, esriVisible],
  props: {
    // The Graphic properties.
    properties: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  watch: {
    visible (value) {
      this.set('visible', value)
    },
    'properties.geometry': {
      handler(value) {
        this.set('geometry', value)
      },
      deep: true
    },
    'properties.symbol': {
      handler(value) {
        this.set('symbol', value)
      },
      deep: true
    }
  },
  methods: {
    /**
     * @Override
     */
    beforeInit () {
      return this.wait(this.getGraphics);
    },
    /**
     * @Override
     */
    async loadEsriModules () {
      return await loadModules(['esri/Graphic']);
    },
    /**
     * @returns {Promise<Map>}
     * @Override
     */
    async createEsriObject () {
      const [Graphic] = this.$esriModules;
      return new Graphic({
        ...this.properties,
        visible: this.visible
      });
    },
    /**
     * @Override
     */
    async mount () {
      this.$esriWatcher = this.$esriObject.watch('visible', visible => {
        this.setVisible(visible);
      });

      const graphics = this.getGraphics();
      if (graphics) {
        graphics.add(this.$esriObject);
      }
    },
    /**
     * @Override
     */
    async unmount () {
      this.$esriWatcher.remove();

      const graphics = this.getGraphics();
      if (graphics) {
        graphics.remove(this.$esriObject);
      }
    }
  }
};
</script>
